import * as React from 'react';

import { SegmentedButtonContainer, SegmentedButtonItem } from './SegmentedButton.styles';

interface SegmentedButtonProps {
  selected: boolean;
  disabled?: boolean;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  children: React.ReactNode;
}

/**
 * Controlled component; no internal state is managed by this component.
 */
const SegmentedButton = ({ selected, disabled, onClick, children }: SegmentedButtonProps) => {
  return (
    <SegmentedButtonItem $selected={selected} $disabled={disabled} onClick={onClick}>
      {children}
    </SegmentedButtonItem>
  );
};

interface SegmentedButtonGroupProps {
  children: React.ReactNode;
}

const SegmentedButtonGroup = ({ children }: SegmentedButtonGroupProps) => {
  return <SegmentedButtonContainer>{children}</SegmentedButtonContainer>;
};

SegmentedButton.Group = SegmentedButtonGroup;

export default SegmentedButton;
